var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #2fe0e6;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke-width: 4px;\r\n      }\r\n\r\n      .cls-3, .cls-4 {\r\n        stroke: #2fe0e6;\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-3, .cls-4, .cls-5 {\r\n        fill: none;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke-width: 1.4px;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke: #62797e;\r\n        stroke-width: 5px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #faffff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.7,24.4c-11.2,0-20.7,9.4-20.7,20.7v2.9h40.7v-2.9c.6-11.8-8.9-20.7-20-20.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78,44.9h7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.7,44.9h7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M69.8,64.5l5.3,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.4,19l5.3,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29.7,64.5l-5.3,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75,19l-5.3,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49.7,72.7v7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.7,9v7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.7,91H3.7l13.6-21.2,9.4-14.7h47.2l9.4,14.7s12.4,21.2,12.4,21.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M49.7,55.1v35.9M49.7,55.1h11.8M49.7,55.1h-11.8M49.7,91h46.6l-13.6-21.2M49.7,91h-23M61.5,55.1h11.8l9.4,14.7M61.5,55.1l11.8,35.9M37.9,55.1h-11.8l-9.4,14.7M37.9,55.1l-11.8,35.9M26.7,91H3.7l13.6-21.2M82.7,69.8H17.3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolar);
export default __webpack_public_path__ + "static/media/solar.74d31609cbd9216156e2b77175817005.svg";
export { ForwardRef as ReactComponent };